import React from "react";
import OptimizedImage from "../../components/image-optimization/OptimizedImage";
import "./clients.css";

const clients = [
  {
    name: "TripAdvisor",
    image: "images/logos/tripadvisor2.png",
    url: "https://www.tripadvisor.fr/Hotel_Review-g187079-d12258612-Reviews-Hotel_Churchill_Bordeaux_Centre-Bordeaux_Gironde_Nouvelle_Aquitaine.html",
  },
  {
    name: "Google",
    image: "images/logos/google.png",
    url: "https://www.google.fr/maps/place/H%C3%B4tel+Churchill+Bordeaux+Centre/@44.8444567,-0.5842103,17z/data=!4m9!3m8!1s0xd5527de0a1e96e3:0x51b6c1b4f2f6a4b7!5m2!4m1!1i2!8m2!3d44.8444529!4d-0.5816354!16s%2Fg%2F11dxdc0xzw?hl=fr&entry=ttu&g_ep=EgoyMDI1MDUyOC4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "Trivago",
    image: "images/logos/trivago.png",
    url: "https://www.trivago.fr/fr/oar/h%C3%B4tel-churchill-bordeaux-centre?search=100-1045764",
  },
];

const Client: React.FC<{ name: string; image: string; url: string }> = ({
  name,
  image,
  url,
}) => {
  return (
    <div className="clients-logo">
      <a href={url} target="_blank" rel="noopener noreferrer">
        <OptimizedImage src={image} alt={name} loading="eager" />
      </a>
    </div>
  );
};

const ClientSection: React.FC = () => {
  return (
    <section className="clients">
      <div className="container">
        <div className="row">
          <div className="col-md-7">
            <div className="owl-carousel owl-theme">
              {clients.map((client) => (
                <Client
                  key={client.name}
                  name={client.name}
                  image={client.image}
                  url={client.url}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientSection;
